/**
 * Pedidos en espera: servidor (sobrevive caché PWA) + copia local de respaldo.
 */

const HELD_ORDERS_KEY = 'pedidos_espera';

function loadPedidosEspera(win) {
	if (!win.pedidosEspera) {
		try {
			win.pedidosEspera = JSON.parse(win.localStorage.getItem(HELD_ORDERS_KEY) || '[]');
		} catch (e) {
			win.pedidosEspera = [];
		}
	}
	if (!Array.isArray(win.pedidosEspera)) {
		win.pedidosEspera = [];
	}
	return win.pedidosEspera;
}

function persistPedidosEspera(win) {
	try {
		win.localStorage.setItem(HELD_ORDERS_KEY, JSON.stringify(loadPedidosEspera(win)));
	} catch (e) {
		console.warn('No se pudo guardar pedidos en espera local:', e);
	}
}

function replaceListaLocal(win, pedidos) {
	const lista = loadPedidosEspera(win);
	lista.splice(0, lista.length, ...(Array.isArray(pedidos) ? pedidos : []));
	persistPedidosEspera(win);
	return lista;
}

function upsertLocal(win, pedido) {
	const lista = loadPedidosEspera(win);
	const id = parseInt(pedido && pedido.id, 10) || 0;
	if (id > 0) {
		const idx = lista.findIndex((p) => parseInt(p.id, 10) === id);
		if (idx >= 0) lista[idx] = pedido;
		else lista.unshift(pedido);
	} else {
		lista.unshift(pedido);
	}
	persistPedidosEspera(win);
	return lista;
}

function removeLocalByIdOrIndex(win, id, index) {
	const lista = loadPedidosEspera(win);
	const sid = parseInt(id, 10) || 0;
	if (sid > 0) {
		const idx = lista.findIndex((p) => parseInt(p.id, 10) === sid);
		if (idx >= 0) lista.splice(idx, 1);
	} else if (index >= 0 && index < lista.length) {
		lista.splice(index, 1);
	}
	persistPedidosEspera(win);
	return lista;
}

function buildPayloadDesdeCarrito(win, numero) {
	const carrito = win.carrito || [];
	const total = carrito.reduce((sum, item) => sum + (parseFloat(item.price) || 0) * (parseFloat(item.cantidad) || 0), 0);
	return {
		numero: numero || `#ESP-${Date.now()}`,
		items: carrito.slice(0),
		cliente: win.clienteSeleccionado || null,
		fecha: new Date().toLocaleString(),
		total,
		mesa: win.mesaSeleccionada || null,
		descuento: win.descuentoActual || null,
		tipoServicio: win.tipoServicioSeleccionado || win.tipoServicio || null,
	};
}

function restaurarContextoPedido(win, $, pedido) {
	if (pedido.cliente) {
		win.clienteSeleccionado = pedido.cliente;
		if (typeof win.mostrarClienteSeleccionado === 'function') {
			win.mostrarClienteSeleccionado();
		} else {
			$('#cliente-nombre').text(pedido.cliente.nombre || '');
			$('#cliente-documento').text(pedido.cliente.documento || '');
			$('#cliente-email').text(pedido.cliente.email || '');
			$('#cliente-badge').text(String(pedido.cliente.nombre || '').substring(0, 10)).show();
			$('#cliente-nombre-compacto').text(pedido.cliente.nombre || '');
			$('#cliente-seleccionado-compacto').show();
			$('#cliente-seleccionado').show();
		}
	} else if (typeof win.resetClienteSeleccion === 'function') {
		win.resetClienteSeleccion(true);
	}

	if (pedido.descuento && typeof win.descuentoActual === 'object') {
		win.descuentoActual = pedido.descuento;
	}
	if (pedido.mesa) {
		win.mesaSeleccionada = pedido.mesa;
		if (typeof win.actualizarBotonesMesa === 'function') win.actualizarBotonesMesa();
	}
}

function actualizarBotonHold(win, $) {
	const activo = win.pedidoEsperaActivo;
	const $btn = $('.btn-hold');
	if (!$btn.length) return;
	if (activo && activo.numero) {
		$btn.attr('title', `Actualizar espera ${activo.numero} en el servidor`);
	} else {
		$btn.attr('title', 'Guardar pedido en espera (servidor)');
	}
}

function apiHeld(win) {
	return win.POSKN && win.POSKN.api ? win.POSKN.api : null;
}

export function attachHeldOrdersGlobals(win, $) {
	loadPedidosEspera(win);

	win.actualizarContadorPedidosEspera = function actualizarContadorPedidosEspera() {
		const count = loadPedidosEspera(win).length;
		$('.btn-view-held').text(`Espera (${count})`);
		actualizarBotonHold(win, $);
	};

	win.posknSincronizarPedidosEspera = function posknSincronizarPedidosEspera() {
		const api = apiHeld(win);
		if (!api || typeof api.heldList !== 'function') {
			win.actualizarContadorPedidosEspera();
			return $.Deferred().resolve({ success: false }).promise();
		}
		const localesSinServidor = loadPedidosEspera(win).filter((p) => !(parseInt(p.id, 10) > 0) && p.items && p.items.length);
		return api.heldList(15000).then((res) => {
			if (res && res.success && res.data && Array.isArray(res.data.pedidos)) {
				replaceListaLocal(win, res.data.pedidos);
			}
			win.actualizarContadorPedidosEspera();
			if (!localesSinServidor.length || typeof api.heldSave !== 'function') {
				return res;
			}
			const chain = localesSinServidor.reduce(
				(prev, local) =>
					prev.then(() =>
						api.heldSave(
							{
								numero: local.numero,
								items: local.items,
								cliente: local.cliente || null,
								total: local.total || 0,
								mesa: local.mesa || null,
								descuento: local.descuento || null,
								tipoServicio: local.tipoServicio || null,
							},
							0,
							20000,
						),
					),
				$.Deferred().resolve().promise(),
			);
			return chain.then(() => api.heldList(15000)).then((again) => {
				if (again && again.success && again.data && Array.isArray(again.data.pedidos)) {
					replaceListaLocal(win, again.data.pedidos);
				}
				win.actualizarContadorPedidosEspera();
				return again;
			});
		});
	};

	win.guardarEnEspera = function guardarEnEspera() {
		const carrito = win.carrito || [];
		if (!carrito.length) {
			win.mostrarNotificacion('El carrito está vacío', 'error');
			return;
		}

		const activo = win.pedidoEsperaActivo || null;
		const numero = (activo && activo.numero) || `#ESP-${Date.now()}`;
		const payload = buildPayloadDesdeCarrito(win, numero);
		const heldId = activo && activo.id ? parseInt(activo.id, 10) : 0;
		const $btn = $('.btn-hold').prop('disabled', true);

		function finalizarLocal(pedido) {
			upsertLocal(win, pedido);
			carrito.splice(0, carrito.length);
			win.pedidoEsperaActivo = null;
			if (typeof win.actualizarCarrito === 'function') win.actualizarCarrito();
			win.actualizarContadorPedidosEspera();
			win.mostrarNotificacion(
				heldId > 0 ? `Espera actualizada: ${pedido.numero}` : `Pedido guardado en servidor: ${pedido.numero}`,
				'success',
			);
		}

		const api = apiHeld(win);
		if (!api || typeof api.heldSave !== 'function') {
			finalizarLocal(payload);
			$btn.prop('disabled', false);
			return;
		}

		api
			.heldSave(payload, heldId, 20000)
			.then((res) => {
				$btn.prop('disabled', false);
				if (res && res.success && res.data && res.data.pedido) {
					finalizarLocal(res.data.pedido);
					win.posknSincronizarPedidosEspera();
					return;
				}
				upsertLocal(win, payload);
				win.mostrarNotificacion(
					`Sin servidor: se guardó en este equipo. ${(res && res.data) || ''}`.trim(),
					'warning',
				);
				carrito.splice(0, carrito.length);
				win.pedidoEsperaActivo = null;
				if (typeof win.actualizarCarrito === 'function') win.actualizarCarrito();
				win.actualizarContadorPedidosEspera();
			})
			.catch(() => {
				$btn.prop('disabled', false);
				upsertLocal(win, payload);
				carrito.splice(0, carrito.length);
				win.pedidoEsperaActivo = null;
				if (typeof win.actualizarCarrito === 'function') win.actualizarCarrito();
				win.actualizarContadorPedidosEspera();
				win.mostrarNotificacion(
					`Sin conexión: ${payload.numero} quedó en este equipo. Al volver la red, ábrelo y vuelve a guardar.`,
					'warning',
				);
			});
	};

	win.verPedidosEspera = function verPedidosEspera() {
		const pintar = (lista) => {
			if (!lista.length) {
				win.mostrarNotificacion('No hay pedidos en espera', 'error');
				return;
			}

			const tasa = win.TASA_DOLAR || 1;
			let modalContent = `
                <div class="modal-overlay" id="modal-pedidos-espera" style="display: flex;">
                    <div class="modal-content" style="max-width: 700px; width: 95%;">
                        <div class="modal-header">
                            <div class="modal-title">📋 Pedidos en Espera (${lista.length})</div>
                            <button class="btn-cerrar" onclick="cerrarModal('modal-pedidos-espera')">&times;</button>
                        </div>
                        <p style="margin:0 16px 8px;font-size:12px;color:#555;">Guardados en el servidor. No se pierden al limpiar la caché de la PWA.</p>
                        <div style="max-height: 500px; overflow-y: auto;">
                            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                                <thead>
                                    <tr style="background: #f5f5f5;">
                                        <th style="padding: 12px; text-align: left; border: 1px solid #ddd;">Número</th>
                                        <th style="padding: 12px; text-align: left; border: 1px solid #ddd;">Fecha</th>
                                        <th style="padding: 12px; text-align: left; border: 1px solid #ddd;">Items</th>
                                        <th style="padding: 12px; text-align: left; border: 1px solid #ddd;">Total</th>
                                        <th style="padding: 12px; text-align: center; border: 1px solid #ddd;">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
            `;

			lista.forEach((pedido, index) => {
				const totalBs = (parseFloat(pedido.total) || 0) * tasa;
				const preview = (pedido.items || [])
					.slice(0, 2)
					.map((item) => {
						const name = item.name || '';
						return name.substring(0, 20) + (name.length > 20 ? '...' : '');
					})
					.join(', ');
				const enServidor = pedido.server || (parseInt(pedido.id, 10) || 0) > 0;

				modalContent += `
                    <tr style="border-bottom: 1px solid #eee;">
                        <td style="padding: 12px; border: 1px solid #ddd;">
                            <strong>${pedido.numero || ''}</strong>
                            ${pedido.cliente ? `<br><small style="color: #666;">${pedido.cliente.nombre || ''}</small>` : ''}
                            <br><small style="color:${enServidor ? '#2e7d32' : '#e65100'};">${enServidor ? 'En servidor' : 'Solo este equipo'}</small>
                        </td>
                        <td style="padding: 12px; border: 1px solid #ddd; font-size: 12px;">${pedido.fecha || ''}</td>
                        <td style="padding: 12px; border: 1px solid #ddd; font-size: 12px;">
                            ${(pedido.items || []).length} productos<br>
                            <small style="color: #666;">
                                ${preview}
                                ${(pedido.items || []).length > 2 ? '...' : ''}
                            </small>
                        </td>
                        <td style="padding: 12px; border: 1px solid #ddd;">
                            <strong style="color: #2196F3;">$${(parseFloat(pedido.total) || 0).toFixed(2)}</strong><br>
                            <small style="color: #4CAF50;">Bs. ${totalBs.toFixed(2)}</small>
                        </td>
                        <td style="padding: 12px; border: 1px solid #ddd; text-align: center;">
                            <button onclick="recuperarPedido(${index})" style="background: #4CAF50; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; font-size: 11px; margin: 2px;">
                                Recuperar
                            </button><br>
                            <button onclick="eliminarPedidoEspera(${index})" style="background: #f44336; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; font-size: 11px; margin: 2px;">
                                Eliminar
                            </button>
                        </td>
                    </tr>
                `;
			});

			modalContent += `
                                </tbody>
                            </table>
                        </div>
                        <div style="text-align: center; padding-top: 16px; border-top: 1px solid #eee;">
                            <button onclick="posknSincronizarPedidosEspera().then(function(){cerrarModal('modal-pedidos-espera');verPedidosEspera();})" style="background: #1976d2; color: white; border: none; padding: 12px 18px; border-radius: 4px; cursor: pointer; margin-right: 8px;">
                                Actualizar lista
                            </button>
                            <button onclick="limpiarTodosPedidosEspera()" style="background: #ff9800; color: white; border: none; padding: 12px 18px; border-radius: 4px; cursor: pointer; margin-right: 8px;">
                                Limpiar todos
                            </button>
                            <button onclick="cerrarModal('modal-pedidos-espera')" style="background: #6b7280; color: white; border: none; padding: 12px 18px; border-radius: 4px; cursor: pointer;">
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            `;

			$('#modal-pedidos-espera').remove();
			$('body').append(modalContent);
		};

		const api = apiHeld(win);
		if (api && typeof api.heldList === 'function') {
			api.heldList(15000)
				.then((res) => {
					if (res && res.success && res.data && Array.isArray(res.data.pedidos)) {
						pintar(replaceListaLocal(win, res.data.pedidos));
						win.actualizarContadorPedidosEspera();
						return;
					}
					pintar(loadPedidosEspera(win));
				})
				.catch(() => pintar(loadPedidosEspera(win)));
			return;
		}
		pintar(loadPedidosEspera(win));
	};

	win.recuperarPedido = function recuperarPedido(index) {
		const carrito = win.carrito || (win.carrito = []);
		if (carrito.length > 0) {
			if (
				!confirm(
					'Ya tienes productos en el carrito. ¿Quieres reemplazarlos con este pedido en espera?',
				)
			) {
				return;
			}
		}

		const lista = loadPedidosEspera(win);
		const pedido = lista[index];
		if (!pedido || !Array.isArray(pedido.items)) return;

		carrito.splice(0, carrito.length, ...pedido.items);
		restaurarContextoPedido(win, $, pedido);
		win.pedidoEsperaActivo = {
			id: parseInt(pedido.id, 10) || 0,
			numero: pedido.numero || '',
		};

		if (typeof win.actualizarCarrito === 'function') win.actualizarCarrito();
		win.actualizarContadorPedidosEspera();

		if (typeof win.cerrarModal === 'function') {
			win.cerrarModal('modal-pedidos-espera');
		}

		win.mostrarNotificacion(
			`Pedido ${pedido.numero} en el carrito. El botón 💾 lo actualiza en el servidor.`,
			'success',
		);
	};

	win.eliminarPedidoEspera = function eliminarPedidoEspera(index) {
		const lista = loadPedidosEspera(win);
		const pedido = lista[index];
		if (!pedido) return;
		if (!confirm(`¿Estás seguro de eliminar el pedido ${pedido.numero}?`)) return;

		const sid = parseInt(pedido.id, 10) || 0;
		const api = apiHeld(win);
		const after = () => {
			removeLocalByIdOrIndex(win, sid, index);
			if (win.pedidoEsperaActivo && parseInt(win.pedidoEsperaActivo.id, 10) === sid) {
				win.pedidoEsperaActivo = null;
			}
			win.actualizarContadorPedidosEspera();
			if (typeof win.cerrarModal === 'function') win.cerrarModal('modal-pedidos-espera');
			setTimeout(() => win.verPedidosEspera(), 100);
			win.mostrarNotificacion(`Pedido ${pedido.numero} eliminado`, 'success');
		};

		if (sid > 0 && api && typeof api.heldDelete === 'function') {
			api.heldDelete(sid, 15000).always(after);
			return;
		}
		after();
	};

	win.limpiarTodosPedidosEspera = function limpiarTodosPedidosEspera() {
		const lista = loadPedidosEspera(win);
		if (!lista.length) {
			win.mostrarNotificacion('No hay pedidos en espera', 'error');
			return;
		}
		if (!confirm(`¿Estás seguro de eliminar todos los ${lista.length} pedidos en espera?`)) return;

		const api = apiHeld(win);
		const after = () => {
			lista.splice(0, lista.length);
			persistPedidosEspera(win);
			win.pedidoEsperaActivo = null;
			win.actualizarContadorPedidosEspera();
			if (typeof win.cerrarModal === 'function') win.cerrarModal('modal-pedidos-espera');
			win.mostrarNotificacion('Todos los pedidos en espera han sido eliminados', 'success');
		};
		if (api && typeof api.heldDeleteAll === 'function') {
			api.heldDeleteAll(15000).always(after);
			return;
		}
		after();
	};

	win.posknConsumirPedidoEsperaActivo = function posknConsumirPedidoEsperaActivo() {
		const activo = win.pedidoEsperaActivo;
		const sid = activo && activo.id ? parseInt(activo.id, 10) : 0;
		win.pedidoEsperaActivo = null;
		actualizarBotonHold(win, $);
		if (sid <= 0) return;
		removeLocalByIdOrIndex(win, sid, -1);
		win.actualizarContadorPedidosEspera();
		const api = apiHeld(win);
		if (api && typeof api.heldDelete === 'function') {
			api.heldDelete(sid, 15000);
		}
	};

	win.actualizarContadorPedidosEspera();
	win.setTimeout(() => {
		if (typeof win.posknSincronizarPedidosEspera === 'function') {
			win.posknSincronizarPedidosEspera();
		}
	}, 900);
}
